import { render, staticRenderFns } from "./FeedbackBox.vue?vue&type=template&id=e7e54e2a&scoped=true&"
import script from "./FeedbackBox.vue?vue&type=script&lang=js&"
export * from "./FeedbackBox.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackBox.vue?vue&type=style&index=0&id=e7e54e2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7e54e2a",
  null
  
)

export default component.exports